const badgeTheme = {
  badge: {
    unknown: {
      color: '#161616',
      background: '#F4F4F4',
    },
    text: {
      color: '#161616',
      background: '#F4F4F4',
    },
    image: {
      color: '#161616',
      background: '#DEE6FD',
    },
    video: {
      color: '#161616',
      background: '#FDDEF6',
    },
    audio: {
      color: '#161616',
      background: '#FFF1CF',
    },
    tabular: {
      color: '#161616',
      background: '#E6FFE7',
    },
    binary: {
      color: '#161616',
      background: '#F4F4F4',
    },
    application: {
      color: '#161616',
      background: '#F4F4F4',
    },
  },
};

export default badgeTheme;
